module.exports = __webpack_public_path__ + "img/sv86on.e2b647d4.svg";